import MultiConditionEditor, {
  ConditionFieldStateWithOperator,
} from "../../MultiConditionEditor"
import { getEditorData } from "../../utils"
import EditorDrawer, { useEditorDrawerState } from "../EditorDrawer"

export default function YesNoSplitNodeEditor({ open, onClose, node }) {
  const {
    newFieldState,
    setNewFieldState,
    tileChanged,
    saveState,
    revertState,
  } = useEditorDrawerState(
    getEditorData(node) || ConditionFieldStateWithOperator.getDefaultState()
  )

  return (
    <EditorDrawer
      open={open}
      onClose={onClose}
      node={node}
      tileChanged={tileChanged}
      editorState={newFieldState}
      onChangesSaved={saveState}
      onChangesDiscarded={revertState}
      title="Yes/No Split"
    >
      <MultiConditionEditor
        conditionFieldsState={newFieldState}
        setConditionFieldsState={setNewFieldState}
        addConditionButtonTitle="Add additional match condition"
      />
    </EditorDrawer>
  )
}
